import { t } from '@/i18n';
import { DayjsSchema, alphanumericStringType, sortOrderType } from '@/utils';
import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../utils';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

export const budgetType = z.enum([
  'initial',
  'supplementary',
  'carried-forward',
  'reserve',
]);

export const BudgetTypeLabelModifier = {
  initial: t('initial-budget'),
  supplementary: t('supplementary-budget'),
  'carried-forward': t('carried-forward-budget'),
  reserve: t('reserve-budget'),
} as const satisfies Record<z.infer<typeof budgetType>, string>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

const BudgetTypeBaseModel = z.object({
  id: z.string().uuid(),
  type: budgetType,
  name: z.string(),
  fiscalYear: z.number().int(),
  sortOrder: sortOrderType,
  createdAt: z.string(),
  updatedAt: z.string(),

  // This properties are only exist when BnS
  externalSystemKey: alphanumericStringType.nullish(),
  scheduledDateOfDecision: z.string().nullish(),
});

export const BudgetTypesModel = BudgetTypeBaseModel.array();

export const BudgetTypeModel = BudgetTypeBaseModel;

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const BudgetTypeFormSchema = BudgetTypeBaseModel.pick({
  externalSystemKey: true,
}).extend({
  type: z.string().min(1),
  name: z.string().min(1).max(NAME_MAX_LENGTH),
  fiscalYear: DayjsSchema(),
  scheduledDateOfDecision: DayjsSchema().nullish(),
});

export const BudgetTypeMutationParamsSchema = BudgetTypeFormSchema.omit({
  fiscalYear: true,
  scheduledDateOfDecision: true,
}).extend({
  fiscalYear: z.string(),
  scheduledDateOfDecision: BudgetTypeBaseModel.shape.scheduledDateOfDecision,
});

export const BudgetTypeSearchFormSchema = z.object({
  fiscalYear: z.string().nullish(),
});

export const UpdateBudgetTypeSortOrderParamsSchema = BudgetTypeBaseModel.pick({
  id: true,
  sortOrder: true,
}).array();
